import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IGenericResponse } from '../../models/IGenericResponse';
import { Administrador, NuevoAdministrador, ParametrosAdministrador } from 'src/app/models/RegistrarAdministrador';

@Injectable({
  providedIn: 'root'
})
export class GestionarAdministradoresService {

  private http = inject(HttpClient);
  private url = environment.api;

  constructor() {}

  getAdministradores() {
    return this.http.get<IGenericResponse>(this.url + "/gestionar-administradores/administradores"); 
  }
  editarAdministrador(administrador: Administrador) {
    return this.http.put<IGenericResponse>(this.url + "/gestionar-administradores/administradores", administrador);
  }  
  crearAdministrador(administrador: ParametrosAdministrador) {
    return this.http.post<IGenericResponse>(this.url + "/gestionar-administradores/administradores", administrador);
  }
}